import { isRejected, type Middleware } from '@reduxjs/toolkit';
import { AppErrorManager } from 'errorHelper';

export const queryErrorLogger: Middleware = () => (next) => (action) => {
  if (isRejected(action)) {
    const { error, payload } = action;
    AppErrorManager.sendError(new Error('rtk_query_error'), {
      extra: {
        error,
        payload,
      },
    });
  }

  return next(action);
};
